import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'emma-confirmation-modal',
    templateUrl: './emma-confirmation-modal.component.html',
    standalone: false
})
export class EMMAConfirmationModalComponent {
  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  @Input() icon = '';
  @Input() headTitle = $localize`Confirmación`;
  @Input() message = $localize`¿Estás seguro de querer realizar esta acción?`;
  @Input() messageHtml = '';
  @Input() confirmText = $localize`Estoy seguro`;
  @Input() cancelText = $localize`Cancelar`;
  @Input() confirmColor = 'brand';
  @Input() cancelColor = 'cancel';
}
